// #region imports
    // #region external
    import Endtime from '../objects/Endtime';
    // #endregion external
// #endregion imports



// #region module
const cli = () => {
    console.log(Endtime.now());
}
// #endregion module



// #region exports
export default cli;
// #endregion exports
